import { RoutesPaths } from "../../../constants/routes"
import { calendarDeepLink } from "../../Calendar/helpers/calendar-deep-link.ts"
import { NOTIFICATION_TYPE, type Notification } from "../types/notification.types.ts"

/** Where clicking a notification opens, or null when it opens nothing. */
export function notificationHref(notification: Notification): string | null {
  const target = notification?.target

  // Its target is the lead's Project row, which the generic case below would
  // open as a project overview. The lead Files tab has no folder view, so the
  // tab itself is where the From Customer files are.
  if (
    Number(notification?.notification_name) ===
    NOTIFICATION_TYPE.LEAD_CUSTOMER_UPLOADED_FILES
  ) {
    const leadId = notification.data?.lead_id || target?.id
    if (leadId)
      return notification.data?.is_project
        ? RoutesPaths.project.view(leadId).files()
        : RoutesPaths.lead.view(leadId, { tab: "files" })
  }

  // A messaging notification names its project, conversation and message, so
  // the link opens that project's Chat tab positioned on that message.
  if (notification.data?.conversation_id && notification.data?.project_id) {
    return RoutesPaths.project.view(notification.data.project_id).messages({
      conversation: notification.data.conversation_id,
      message: notification.data.message_id
    })
  }

  // A signature notification names its record; a lead keeps its requests on the Documents tab.
  if (notification.data?.envelope_id && notification.data?.lead_id) {
    const recordId = notification.data.lead_id
    return notification.data.is_project
      ? RoutesPaths.project.view(recordId).files()
      : RoutesPaths.lead.view(recordId, { tab: "documents" })
  }

  switch (target?.type) {
    case "project":
      return RoutesPaths.project.view(target.id).overview
    case "lead":
      return RoutesPaths.lead.view(target.id)
    case "calendarevent":
      return calendarDeepLink(undefined, notification.data?.event_id || target.id)
    case "subcontractor":
      // EAD-1553, Chen's F7: "each alert should open the relevant document and
      // action". A compliance-expiry notification already carries the document
      // type, so it can land on the Documents & Compliance tab at that row —
      // where Upload/Replace is. Anything else about a subcontractor still
      // opens the profile, as does an older expiry row written before the
      // document type was on the payload.
      return RoutesPaths.subcontractors.view(
        target.id,
        notification.data?.document_type
          ? { tab: "documents", document: String(notification.data.document_type) }
          : undefined
      )
    default:
      return null
  }
}
